export default "__VITE_ASSET__pSfZzXGA__"